import { Register8 } from '@/Emulator/Utility';

export class ControlRegister extends Register8
{
    public static readonly NMI_VBLANK_BIT: number                = 7;
    public static readonly SPRITE_SIZE_16_BIT: number           = 5;
    public static readonly BACKGROUND_PATTERN_TABLE_BIT: number = 4;
    public static readonly SPRITE_PATTERN_TABLE_BIT: number     = 3;
    public static readonly INCREMENT_ADDRESS_BIT: number        = 2;
    public static readonly NAME_TABLE_ADDRESS_BIT: number        = 0;
    public static readonly NAME_TABLE_ADDRESS_BITS_WIDTH: number = 2;

    constructor()
    {
        super(new Uint8Array(1), 0);
    }

    public isNmiEnabled(): boolean
    {
        return this.hasBit(ControlRegister.NMI_VBLANK_BIT);
    }

    public clearNmiEnabled(): void
    {
        this.setBit(ControlRegister.NMI_VBLANK_BIT, false);
    }

    public setNmiEnabled(): void
    {
        this.setBit(ControlRegister.NMI_VBLANK_BIT, true);
    }

    public isSpriteSize16(): boolean
    {
        return this.hasBit(ControlRegister.SPRITE_SIZE_16_BIT);
    }

    public isIncrementAddress(): boolean
    {
        return this.hasBit(ControlRegister.INCREMENT_ADDRESS_BIT);
    }

    public getBackgroundPatternTable(): number
    {
        return this.getBit(ControlRegister.BACKGROUND_PATTERN_TABLE_BIT);
    }

    public getSpritePatternTable(): number
    {
        return this.getBit(ControlRegister.SPRITE_PATTERN_TABLE_BIT);
    }

    public getNameTableAddress(): number
    {
        return this.getBits(
            ControlRegister.NAME_TABLE_ADDRESS_BIT,
            ControlRegister.NAME_TABLE_ADDRESS_BITS_WIDTH
        );
    }
}
